/*** Pre Define Constant Values For Product Listing Api Call Start ***/
// const shopUrl = "https://"+window.Shopify.shop;
// const collectionHandel = "engagement-rings-melbourne";
/*** Pre Define Constant Values For Product Listing Api Call End ***/

/*** Diamond Price Filter End ***/
function getPriceCalibArray(minDiamondPrice,maxDiamondPrice) {
  var price = [];

  for (var i = parseInt(minDiamondPrice); (i < 500 && i<maxDiamondPrice); i = i+10) {
    price.push(i);
  };
  for (var i = 500; (i < 1000 && i<maxDiamondPrice); i = i+15) {
    price.push(i);
  };
  for (var i = 1000; (i < 1500 && i<maxDiamondPrice); i = i+20) {
    price.push(i);
  };
  for (var i = 1500; (i < 2000 && i<maxDiamondPrice); i = i+25) {
    price.push(i);
  };
  for (var i = 2000; (i < 3000 && i<maxDiamondPrice); i = i+30) {
    price.push(i);
  };
  for (var i = 3000; (i < 4000 && i<maxDiamondPrice); i = i+35) {
    price.push(i);
  };
  for (var i = 4000; (i < 4500 && i<maxDiamondPrice); i = i+40) {
    price.push(i);
  };
  for (var i = 4500; (i < 5000 && i<maxDiamondPrice); i = i+45) {
    price.push(i);
  };
  // for (var i = 5000; i < 25000; i = i+50) {
  //   price.push(i);
  // };
  // for (var i = 25000; i < 50000; i = i+100) {
  //   price.push(i);
  // };
  // for (var i = 50000; i < 80000; i = i+200) {
  //   price.push(i);
  // };
  // for (var i = 80000; i < 100000; i = i+1000) {
  //   price.push(i);
  // };
  // for (var i = 100000; i < 200000; i = i+1000) {
  //   price.push(i);
  // };
  
  price.push(parseInt(maxDiamondPrice));
  return price;
}

function get_priceindex(price_min,price_max,value) {
    var price = getPriceCalibArray(price_min,price_max);  
	var pos = 0
	for (i = 0; i < price.length; i++) {
		if (price[i] == value) {
			pos = i;
			break;
		}
	}
	return pos;
}
  
function price_slider_render(min_price,max_price,option,filterLabel){
    var price = getPriceCalibArray(default_price_min,default_price_max);
  
    var minPrice = getClosestNum(min_price,price);
    var maxPrice = getClosestNum(max_price,price);  
    var price_min = get_priceindex(default_price_min,default_price_max,minPrice); 
    var price_max = get_priceindex(default_price_min,default_price_max,maxPrice);   

    //session price filter selected
    var isSelected = false;
    if(min_price != default_price_min || max_price != default_price_max){
       isSelected = true;
    }
    var filterValues = filterLabel+': '+Shopify.formatMoney(min_price*100, theme.moneyFormat)+' - '+Shopify.formatMoney(max_price*100, theme.moneyFormat);   
    setSettingSelectedFilter(filterValues,"price_slider_render('"+default_price_min+"', '"+default_price_max+"','true','"+filterLabel+"')",isSelected,'price');
     //end
   
        jQuery("#tps_price_slider").slider({
            range: true,
            min: 0,
            max: price.length-1,
            values: [ price_min,price_max ],
            step:0.1,
            slide: function( event, ui ) { 
                if ((ui.values[0]) > (ui.values[1])) { 
                    return false; 
                }
                jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
                jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
    
                var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])]*100, theme.moneyFormat);
                jQuery('#price_from').val(price_form);
                var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])]*100, theme.moneyFormat);
                jQuery('#price_to').val(price_to);

                option = true;
            },
            change: function(event, ui) {
              var resetFlag = checkResetFlag();
              emptyProductResultDiv();         
              if(option == true) {                         
                 jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
                 jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
                
                 var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])]*100, theme.moneyFormat);
                 jQuery('#price_from').val(price_form);
                 var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])]*100, theme.moneyFormat);
                 jQuery('#price_to').val(price_to);
                  
                 //applied filters 
                 var isSelected = false;
                 
                 if(price[parseInt(ui.values[0])] != default_price_min || price[parseInt(ui.values[1])] != default_price_max){
                    isSelected = true;
                 }           
                
                 var filterValues = filterLabel+': '+price_form+' - '+price_to;          
                 
                 setSettingSelectedFilter(filterValues,"price_slider_render('"+default_price_min+"', '"+default_price_max+"','true','"+filterLabel+"')",isSelected,'price');

                 updateSessionFilters(session_variable+'-filters',filterLabel, price[parseInt(ui.values[0])]+","+price[parseInt(ui.values[1])]);
                 //end                               

                 if(resetFlag != 'true'){
                    jQuery('#page_no').val(1);
                    jQuery('#pagination').val('');
                    ajaxDataCall();
                 }
                 slide = '';
                 return false;
              }else if(option == false) {
                   jQuery('#price_left_hidden').val(min_price);
                   jQuery('#price_right_hidden').val(max_price);
      
                   var price_form = ""+Shopify.formatMoney(min_price*100, theme.moneyFormat);
                   jQuery('#price_from').val(price_form);
                   var price_to = ""+Shopify.formatMoney(max_price*100, theme.moneyFormat);
                   jQuery('#price_to').val(price_to);

                   updateSessionFilters(session_variable+'-filters',filterLabel, min_price+","+max_price);

                   if(resetFlag != 'true'){
                     jQuery('#page_no').val(1);
                     jQuery('#pagination').val(''); 
                     setTimeout(function(){
                       ajaxDataCall();
                     }, 10);
                   }

                   setTimeout(function(){
                     option = true;
                   }, 25); 
                   slide = '';
                   
                   return false;
                }
            }
             
        });
  		  
      var start_num = parseInt(min_price);
      var end_num = parseInt(max_price);

      var start_dec = start_num.toFixed(0);
      var end_dec = end_num.toFixed(0);

     jQuery('#price_left_hidden').val(start_dec);
     jQuery('#price_right_hidden').val(end_dec);  		 
     jQuery('#price_from').val(Shopify.formatMoney(start_dec*100, theme.moneyFormat));  
     jQuery('#price_to').val(Shopify.formatMoney(end_dec*100, theme.moneyFormat));
}


/*** Price Validation Start ***/
$("#price_to").keypress(function(e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});

$("#price_from").keypress(function(e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});
/*** Price Validation End ***/

function replace_price_from(ele,priceMin,filterLabel) {   
	if (jQuery('#price_from').val() == '') {
		var value = parseFloat(jQuery('#price_left_hidden').val());          
        var formatted_max_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
		jQuery('#price_from').val(formatted_max_price);
		return false;
	} else {
		var price_min = jQuery('#price_from').val();
	}
  
    var price_min_value = parseInt(getPriceWithoutSymbolAndCommas(price_min));
	var price_max_value = parseInt(jQuery('#price_right_hidden').val());
  
    var default_price_min_value = parseFloat(default_price_min);
    var formatted_min_price = ""+Shopify.formatMoney(default_price_min_value*100, theme.moneyFormat);
  
	if (isNaN(price_min_value) != false) {    
        alert(translations.titlePleaseEnterValueInNumber);  
		jQuery('#price_from').val(formatted_min_price);
        return false;
	} else if (price_min_value < default_price_min) {  
        alert(translations.titleIncorrectPriceRange);		
		jQuery('#price_from').val(formatted_min_price);
		return false;
	} else if (price_min_value > price_max_value) { 
        alert(translations.titleIncorrectPriceRange);        
		price_slider_render(default_price_min, price_max_value, false, filterLabel);
		return false;
	}

	jQuery('#price_left_hidden').val(price_min_value.toFixed(0));
	jQuery('#price_right_hidden').val(price_max_value.toFixed(0));
	price_slider_render(price_min_value, price_max_value, false, filterLabel);

}

function replace_price_to(ele,priceMax,filterLabel) {
	if ($('#price_to').val() == ''){
		var value = parseFloat($('#price_right_hidden').val());
        var formatted_min_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
		$('#price_to').val(formatted_min_price);        
		return false;
	} else {
		var price_max = $('#price_to').val();        
	}

    var price_max_value = parseInt(getPriceWithoutSymbolAndCommas(price_max));
    var price_min_value = parseInt(jQuery('#price_left_hidden').val());

    var default_price_max_value = parseFloat(default_price_max);
    var formatted_max_price = ""+Shopify.formatMoney(default_price_max_value*100, theme.moneyFormat);
  
	if (isNaN(price_max_value) != false) {
        alert(translations.titlePleaseEnterValueInNumber);        
		jQuery('#price_to').val(formatted_max_price);
        return false;
	} else if (price_max_value > default_price_max) {         
        alert(translations.titleIncorrectPriceRange);
		jQuery('#price_to').val(formatted_max_price);        
		return false;
	} else if (price_min_value > price_max_value) {       
        alert(translations.titleIncorrectPriceRange);
		jQuery('#price_to').val(formatted_max_price);        
		return false;
	} else if (price_min_value == '') {
		jQuery('#price_from').val(price_min_value);
	}

	jQuery('#price_right_hidden').val(price_max_value.toFixed(0));
	jQuery('#price_left_hidden').val(price_min_value.toFixed(0));
	price_slider_render(price_min_value, price_max_value, false, filterLabel);
}

function getPriceWithoutSymbolAndCommas(input_price) {
  var price = input_price;
  if(input_price.indexOf("$") >= 0){
    price = input_price.replace('$', '');
    price = price.replace(/[^\d\.]/g, '');
  }else if(input_price.indexOf("€") >= 0){
    price = input_price.replace('€', '');
    price = price.replace(/\./g, '');   
  }
  return price;
}
/*** Diamond Price Filter End ***/

/*** Sort Filter Start ***/ 
$(document).on("click", ".tps-sort-option", function() {
  sortByClose();
  emptyProductResultDiv();
  
  var sort_by = $(this).attr('data-sort');
  var sort_title = $(this).attr('data-title');
  var sort_type = $(this).attr('data-type');
  
  jQuery('#sort_by').val(sort_by);

  jQuery('.tps-sort-by-value').html('<span>'+sort_title+'</span>');
  jQuery('.tps-sort-option').removeClass('active');
  jQuery('.tps-sort-'+sort_by).addClass('active');
  
  jQuery('#page_no').val(1);
  
  ajaxDataCall(); 
  
  updateSessionFilters(session_variable+'-other-data','Sort-By',sort_by);
  updateSessionFilters(session_variable+'-other-data','Sort-Title',sort_title);
});
/*** End ***/

/*** Set Session Selected Sort Filter Start ***/
function setSessionSelectedSortValues(sortBy,sortTitle) {  
  jQuery('.tps-sort-option').removeClass('active');
  jQuery('.tps-sort-'+sortBy).addClass('active');  

  jQuery('.tps-sort-by-value').html(sortTitle);
}
/*** Set Session Selected Sort Filter End ***/

/*** CheckBox Type Filter Selection Common Function Start ***/
function setSettingCheckboxtypeFilter(ele,parentClass,valueid,filter){  
     var filter_value = jQuery(ele).find("input").attr('data-value');
     var filterLable = filter.toLowerCase(); 
     emptyProductResultDiv();

     //console.log("filter_value",filter_value);
     //console.log("filterLable",filterLable);
     if(jQuery(ele).hasClass('selected')){
        filter_value = '';
        jQuery(ele).removeClass('selected');
        $('#'+valueid).val('');
     }else{     
        jQuery('.tps-filter-'+filterLable+'-li').removeClass('selected');
        jQuery(ele).addClass('selected');
         $('#'+valueid).val(filter_value);
     }  
       
    jQuery('#page_no').val(1);
    ajaxDataCall();
    updateSessionFilters(session_variable+'-filters',filter, filter_value);
  
    //Applied filter code start 
    var filterTitle = filter+': '+filter_value;
    var filterFunction = "remove"+filter+"Filter('"+filter_value+"')"; 
    var hasClass = jQuery(ele).hasClass('selected');
    setSettingSelectedFilter(filterTitle,filterFunction,hasClass,filterLable);
    //end  
}
/*** End ***/

/*** Remove Shape Filter From Applied Filter Start ***/
function removeShapeFilter(shape){ 
  jQuery('.tps-filter-shape-list input[data-value="'+shape+'"]').click();
}
/*** Remove Shape Filter From Applied Filter End ***/

/*** Remove Metal Filter From Applied Filter Start ***/
function removeMetalFilter(metal){ 
  jQuery('.tps-filter-metal-list input[data-value="'+metal+'"]').click();
}
/*** Remove Metal Filter From Applied Filter End ***/

/*** Remove Style Filter From Applied Filter Start ***/
function removeStyleFilter(style){ 
  jQuery('.tps-filter-style-list input[data-value="'+style+'"]').click();
}
/*** Remove Style Filter From Applied Filter End ***/

/*** Set Selected Filters For Session Filters After Reloading Page start ***/
function setSettingSelectedFilter(filter_value, func, hasSelectedClass, input_value = '') {    
	if (input_value == 'price') {
		$('.tps-selected-filter-container').find('li[data-input="price"]').remove();
	}else if (input_value == 'shape') {     
		$('.tps-selected-filter-container').find('li[data-input="shape"]').remove();
	}else if (input_value == 'style') {
		$('.tps-selected-filter-container').find('li[data-input="style"]').remove();
	}else if (input_value == 'metal') {
		$('.tps-selected-filter-container').find('li[data-input="metal"]').remove();
    }
  
	var value = filter_value.split(':');
   
	if (hasSelectedClass) {
		var html = '';
        var filter_lable = value[1].trim();
        if(input_value != 'price') {
          //filter_lable = filter_lable.replace(/\-/g, ' ');
        }
		html += '<li onclick="' + func + '" data-input="' + input_value + '" data-filter-value="' + filter_value + '"><div class="tps-filter-values">' + filter_lable + '<span class="tps-filter-remove-option"></span></div></li>';
		if ($('#' + value[0] + '-container').length > 0) {
			$('#' + value[0] + '-container').append(html);
		} else {
			var elecontainer = '<ul id="' + value[0] + '-container"><span class="tps-applied-filter-lable">' + value[0] + ':</span></ul>';
			$('.tps-selected-filter-container').append(elecontainer);
			$('#' + value[0] + '-container').append(html);
		}    
	} else {
		$('.tps-selected-filter-container').find('li[data-filter-value="' + filter_value + '"]').remove();
		if ($('input[value="' + input_value + '"]').length > 0) {
			$('input[value="' + input_value + '"]').prop('checked', false);
		}

		if ($('#' + value[0] + '-container li').length == 0) {
			$('#' + value[0] + '-container').remove();
		}
	}
	if ($('.tps-selected-filter-container li').length > 0) {
		$('.tps-selected-filter-wrapper').show();
	} else {
		$('.tps-selected-filter-wrapper').hide();
	}
}
/*** Set selected filters for session filters after reloading page end ***/

/*** Insert Session Selected Values In Input Fields Start ***/
function getSessionSelectedSettingFilterValues(session_data) {  
  $.each(session_data, function(key,value){ 
    var inputKey = key.toLowerCase();
    
    if(key == 'Shape' || key == 'Metal' || key == 'Style'){    
        if(value != ''){
          var inputValues = value.toString();          
          $('#setting_'+inputKey).val(inputValues);
    
          var filterArrayKey = key;
          var filterArrayValues = value;
    
          setTimeout(function(){ 
            setSessionSelectedSettingCheckBoxFilters(filterArrayKey,filterArrayValues);
          }, 50);  
        }
    }else if(key == 'Price'){
      $('#'+inputKey+'_left_hidden').val(value[0]);
      $('#'+inputKey+'_right_hidden').val(value[1]);
    }
     
  });    
}
/*** Insert Session Selected Values In Input Fields End ***/

/*** Set Session Selected Checkbox Type Filters Start ***/
function setSessionSelectedSettingCheckBoxFilters(filterKey,filterValues) {
  $(filterValues).each(function(index, value) {        
      var filterTitle = filterKey.toLowerCase();
      var filterValue = value.toLowerCase();
      
      if(filterTitle != 'shape'){
        filterValue = filterValue.replace(/\s+/g, '-');
      }
    
      $(".tps-filter-"+filterTitle+"-checkbox-"+filterValue).prop('checked', true);
      $(".tps-filter-"+filterTitle+"-"+filterValue).addClass('selected');
       
      var filterSelectedValues = filterKey+': '+value; 
      setSettingSelectedFilter(filterSelectedValues,"remove"+filterKey+"Filter('"+value+"')",true,filterTitle);
   });  
}
/*** Set Session Selected Checkbox Type Filters End ***/

/*** Get All Setting Products Start ***/ 
function ajaxDataCall(){   
   var session_variable = jQuery("#session_variable").val();
   var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));
     
   jQuery(".tps-productlist-result-grid-view-loader").show();
   jQuery("#tps_product_count").html("(<span class='tps-product-count-loader'></span>)");
   //var ringSettingUrl = shopUrl+'/collections/'+collectionHandel+'/products.json?limit=250&page=1'; //get ring setting products using shopify api
   var ringSettingUrl = settingJsonUrl;
   var prodGridView = '';

   var session_flag = 0;
   if(session_other_data != '' && session_other_data != null){
      if(session_other_data['Product-Id'] != null && session_other_data['Product-Id'] != '' && session_other_data['Product-Id'] != undefined){
        if(session_other_data['Product-Id'][0] != undefined){
          var session_flag = 1;
        }
      }
   }

  var productsPerPage = jQuery("#products_per_page").val();
  // console.log(products_per_page);
  if(session_flag != 0){
    var recentPageNo = session_other_data['Recent-Product-Page-No'][0];
    jQuery("#page_no").val(recentPageNo);
    var pageNo = recentPageNo;
    var productShow = recentPageNo * productsPerPage;
    var showFrom = 0;
    var showTo = parseInt(productShow) - 1;
  }else{
     var pageNo = jQuery("#page_no").val();
     var productShow = pageNo * productsPerPage;
     var showFrom = productsPerPage * (pageNo - 1);
     var showTo = parseInt(showFrom) + parseInt(productsPerPage) - 1;
   }       

   abortAjax(xhr);

   var productDataArray = [];
  
   xhr = $.ajax({
     type: 'GET',
     url: ringSettingUrl,
     dataType: 'json',
     success: function (data){  
              
       
       var productsData = productFilters(data); //product filter function  
       var productCount = productsData.length;
       jQuery("#tps_product_count").html("("+addCommas(productCount)+")");
       jQuery("#total_products_count").val(productCount);
       jQuery(".tps-total-products").html(addCommas(productCount));

       if(parseInt(productCount) > 0){
         $('.tps-product-grid-view-container').removeClass('tps-no-product');
         var swatchesData = new Array();

         // setTimeout(function(){
           $.each(productsData, function (i, product) {    
             if(i >= showFrom && i <= showTo){
               prodGridView += getProductGridViewLayout(product,collectionHandel,i);  
             }
           });
         
         // }, 500);

         jQuery('.tps-productlist-result-grid-view-items-list').append(prodGridView);         
       }else{
         //no products found
          jQuery('.tps-productlist-result-grid-view-items-list').html('');
          prodGridView += '<span class="tps-no-product-found">'+translations.titleNoProductFound+'</span>';      
          jQuery('.tps-productlist-result-grid-view-items-list').addClass('tps-no-product-found'); 
          jQuery('.tps-productlist-result-grid-view-items-list').append(prodGridView);  
       }       

       if(productCount < productsPerPage || productCount == productsPerPage){
          var previous_page_no = parseInt(pageNo)-1;
          var total_previous_products = previous_page_no*productsPerPage;
          var products_viewed = parseInt(total_previous_products)+parseInt(productCount);        
          if(productCount == 0){
            var products_viewed = productCount;
          }else{
            var products_viewed = parseInt(total_previous_products)+parseInt(productCount);            
          }                    
          jQuery('.tps-total-products-displays').html(addCommas(products_viewed));
          jQuery(".tps-load-more").hide();
      }else{       
          if(pageNo == 1){      
              var products_viewed = productsPerPage;
          }else{
              var products_viewed = pageNo*parseInt(productsPerPage);
              if(products_viewed > productCount){
                products_viewed = productCount;
              }
          }    
          jQuery('.tps-total-products-displays').html(addCommas(products_viewed));
          jQuery(".tps-load-more").show();
      }  

       //product info focus return from product detail page          
        if(session_flag != 0){
            var recentProduct = session_other_data['Product-Id'][0];            
            focusRecentProduct(recentProduct);            
        }             
        //end 

       jQuery(".tps-productlist-result-grid-view-loader").hide();
       var page_id = parseInt(pageNo)+1;  
       jQuery('#page_no').val(page_id);       
     }

   });
}
/*** Get All Setting Products End ***/ 

/*** Focus Recently View Product Start ***/
function focusRecentProduct(product_id) {
  var target = '.product-grid-item-'+product_id;

  if($(target).length) {
    $(target).addClass('tps-recent-viewed-product');
    $('html, body').animate({
          scrollTop: $(target).offset().top - 300
    }, 'slow'); 
  }  
  updateSessionFilters(session_variable+'-other-data','Product-Id', '');
  updateSessionFilters(session_variable+'-other-data','Recent-Product-Page-No', '');
  setTimeout(function(){ $(target).removeClass('tps-recent-viewed-product'); }, 1500);
}
/*** End ***/

/*** Get Product Grid View layout Start ***/ 
function getProductGridViewLayout(product,collectionHandel,diamondIndex){
  var wishlistProducts = jQuery("#wishlist_products").val();
  wishlistProducts = wishlistProducts.split(",");
 
  var banner_display_count = jQuery('#tps_banner_row_count').val();
  var diamond_index = (diamondIndex % 40)+1;   
 
   //Get Hover Image
  var images = product.images;
  const altAndSrc = images.map(image => ({
    alt: image.alt,
    src: image.src
  }));

  // console.log(altAndSrc)
  var pageNo = jQuery("#page_no").val();
  var metalFilter = jQuery("#setting_metal").val();
  var filteredMetal = metalFilter.replace(/^18K\s/, '');
 

  // Filter images, ensuring alt exists and starts with the filteredMetal
  const filteredImages = altAndSrc.filter(item => 
    item.alt && typeof item.alt === 'string' && item.alt.startsWith(filteredMetal)
  );
  
  // Get the appropriate src based on the condition
  const singleSrc = filteredImages.length > 0 
    ? (filteredImages[1] ? filteredImages[1].src : filteredImages[0].src) // Use the 1st position image if it exists, otherwise the 0th position
    : altAndSrc[0].src; // Fallback to the 0th position image from the original array
  
  
  console.log(product);
  var produtSwaches = getProductSwatches(product,collectionHandel);  
  var productVariant = getProductVariant(product,collectionHandel); 
  // console.log('productVariant',productVariant);
  var productPrice = Shopify.formatMoney(productVariant[0].price * 100, theme.moneyFormat);
  var productImage = productVariant[0].image;    
  if(productImage.includes('.png')){
    productImage = productImage.replace(".png","_300x300.png");
  }else if(productImage.includes('.jpg')){
    productImage = productImage.replace(".jpg","_300x300.jpg");
  }

  // Create image array for navigation
  var productImageArray = [productImage];
  if (singleSrc && singleSrc !== productImage) {
    productImageArray.push(singleSrc);
  }
  
  // Add other relevant product images
  for (var i = 0; i < images.length; i++) {
    var imgSrc = images[i].src;
    if (imgSrc !== productImage && imgSrc !== singleSrc) {
      productImageArray.push(imgSrc);
    }
  }

  var productGrid = '';
  productGrid += '<li class="tps-productlist-result-grid-view-item product-grid-row product-grid-item-'+product.id+'" data-id="'+product.id+'" data-page="'+pageNo+'">'; 
  productGrid += '<div class="tps-productlist-item-media-div-section tps-productlist-item-media-div-'+product.id+'">';
  productGrid += '<div class="tps-productlist-wishlist tps-product-wishlist-'+product.id+'" onClick="addRemoveProductToWishlist(`'+product.id+'`,`product`)">';
  productGrid += '<button class="love-button" gropulse-lbw-product-id="'+product.id+'">';
  productGrid += '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#13177a" class="bi bi-heart" viewBox="0 0 16 16" id="IconChangeColor">';
  if(jQuery.inArray(product.id.toString(),wishlistProducts)==(-1)){
    productGrid += '<path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.920 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z" id="mainIconPathAttribute" stroke-width="0.3" stroke="#13177a" fill="#13177a"></path>';
  }else{
    productGrid += '<path d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z" id="mainIconPathAttribute" stroke-width="0.3" stroke="#13177a" fill="#13177a"></path>';
  }
  productGrid += '</svg></button>';  
  productGrid += '</div>';
  productGrid += '<a href="'+productVariant[0].url+'" data-id="'+product.id+'" data-page="1">';
  
  // Add image container with navigation arrows
  productGrid += '<div class="tps-productlist-item-media-div tps-product-img-nav">';
  
  // Only show navigation arrows if there are multiple images
  if (productImageArray.length > 1) {
    productGrid += '<div class="tps-product-arrow tps-product-prev-arrow" onclick="changeProductImage(event, \''+product.id+'\', \'prev\')"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg></div>';
    productGrid += '<div class="tps-product-arrow tps-product-next-arrow" onclick="changeProductImage(event, \''+product.id+'\', \'next\')"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg></div>';
  }
  
  productGrid += '<img class="tps-productlist-item-img tps-product-first-image" data-placeholder-img="" data-current-index="0" data-product-id="'+product.id+'" data-image-list="'+productImageArray.join(',')+'" alt="'+product.title+'" title="'+product.title+'" src="'+productImage+'" width="300" height="300">';
  productGrid += '<img class="tps-productlist-item-img tps-product-second-image" data-placeholder-img="" alt="'+product.title+'" title="'+product.title+'" src="'+singleSrc+'" width="300" height="300">';
  productGrid += '</div>';
  productGrid += '</a>';
  productGrid += '</div>';
  
  productGrid += '<div class="tps-productlist-item-wrapper">';
  if(produtSwaches != '' && produtSwaches != null){
   // console.log("produtSwaches",produtSwaches);
    productGrid += '<div class="tps-productlist-item-swatches">';
    console.log(produtSwaches);
    $.each(produtSwaches, function (i, swatch) {  
      var metalSwatch = swatch.metal;
      metalSwatch = metalSwatch.replace(/^18K\s/, '');
    //console.log("swatch",metalSwatch);
      var matchingImages = images.filter(image => image.alt === metalSwatch);
      const imageSrcs = matchingImages.map(image => image.src);
       //console.log(imageSrcs);
      let firstImageUrl = '';
      if (imageSrcs.length > 0) {
          firstImageUrl = imageSrcs[1];
      }
      //console.log(firstImageUrl);
     
      productGrid += '<div class="tps-productlist-item-swatch tps-productlist-item-swatch-'+swatch.id+' '+swatch.active+'" parent-id="'+product.id+'" data-id="'+swatch.id+'">';
      productGrid += '<div title="'+swatch.metal+'" data-id="'+swatch.id+'" onclick="changeProductData(`'+product.title+'`,`'+product.id+'`,`'+swatch.id+'`,`'+swatch.metal+'`,`'+swatch.price+'`,`'+swatch.image+'`,`'+swatch.url+'`,`'+firstImageUrl+'`)">';
      productGrid += '<span class="tps-productlist-item-metal-icon metal-'+swatch.class+'">'+swatch.metal+'</span>';
      productGrid += '</div>';
      productGrid += '</div>';
    });
    productGrid += '</div>';
  }
  
  productGrid += '<div class="tps-productlist-item-view-info tps-productlist-item-view-info-'+product.id+'">';
  productGrid += '<a href="'+productVariant[0].url+'" data-id="'+product.id+'" data-page="1">';
  productGrid += '<div class="tps-productlist-item-view-title">'+product.title+'</div>';  
  productGrid += '<div class="tps-productlist-item-view-price">'+productPrice+'</div>'; 
  productGrid += '</a>';
  productGrid += '</div>';
  productGrid += '</div>';
  productGrid += '</li>';

  //banner start  
  if(jQuery(window).width() > 900 && jQuery(window).width() < 1198){    
    banner_display_count = parseInt(banner_display_count)+1; //for tab view display banner after 21 diamonds
  }
  
   
  if(diamond_index == banner_display_count){
    // console.log("pageNo",pageNo);
      var bannerHtml = $('#tps_banner_blog_'+pageNo).html();
   // console.log("bannerHtml",bannerHtml);
      if(bannerHtml != '' && bannerHtml != undefined){
        productGrid += '<li class="tps-diamondlist-banner-section">';
        productGrid += '<div class="tps-diamond-listing-page-banner">'+bannerHtml+'</div>';
        productGrid += '</li>';
      }
  }  
  //banner end

  return productGrid;
}
/*** Get Product Grid View layout End ***/

/*** On Swatches Click Change Variant Data Start ***/
function changeProductData(productTitle,productId,variantId,variantTitle,variantPrice,variantImage,variantUrl,hoverImg) { 
  jQuery('.product-grid-item-'+productId+' .tps-productlist-item-swatch').removeClass('active');
  jQuery('.tps-productlist-item-swatch-'+variantId).addClass('active');
  jQuery('.tps-productlist-item-media-div-'+productId).addClass('tps-gallery-loading');   
  var productPrice = Shopify.formatMoney(variantPrice * 100, theme.moneyFormat);

  var productMedia = '';
  productMedia += '<a href="'+variantUrl+'" data-id="'+productId+'" data-page="1">';
  productMedia += '<div class="tps-productlist-item-media-div">';
  productMedia += '<img class="tps-productlist-item-img tps-product-first-image" data-placeholder-img="" alt="'+productTitle+'" title="'+productTitle+'" src="'+variantImage+'" width="300" height="300">';
  if (hoverImg !== '' && hoverImg !== null && hoverImg !== undefined){
     productMedia += '<img class="tps-productlist-item-img tps-product-second-image" data-placeholder-img="" alt="'+productTitle+'" title="'+productTitle+'" src="'+hoverImg+'" width="300" height="300">';
  }else{
     productMedia += '<img class="tps-productlist-item-img tps-product-second-image" data-placeholder-img="" alt="'+productTitle+'" title="'+productTitle+'" src="'+variantImage+'" width="300" height="300">';
  } 
  productMedia += '</div>';
  productMedia += '</a>';  
  jQuery('.tps-productlist-item-media-div-'+productId).html(productMedia);  

  var productinfo = '';
  productinfo += '<a href="'+variantUrl+'" data-id="'+productId+'" data-page="1">';
  productinfo += '<div class="tps-productlist-item-view-title">'+productTitle+'</div>';  
  productinfo += '<div class="tps-productlist-item-view-price">'+productPrice+'</div>'; 
  productinfo += '</a>';
  jQuery('.tps-productlist-item-view-info-'+productId).html(productinfo);  
  jQuery('.tps-productlist-item-media-div-'+productId).removeClass('tps-gallery-loading');   
}
/*** On Swatches Click Change Variant Data End ***/

/*** Get variant Data After Filter Apply Start ***/
function getProductVariant(product,collectionHandel){
  var variantData = new Array();
  var shapeFilter = jQuery("#setting_shape").val();  
  var metalFilter = jQuery("#setting_metal").val(); 
  var productVariants = product.variants;
  var productHandle = product.handle;   
  var productMedia = product.images;
  var i = 0;

  if(productVariants != ''){
     $(productVariants).each(function(index, option){
       var variantShape = option.option1;
       var variantMetal = option.option2;
       
       if(shapeFilter == '' && metalFilter == ''){
         if(i == 0){
           variantData = getProductSelectedOption(option,productHandle,productMedia,collectionHandel);
           
           i++;
         }
       }else if(shapeFilter != '' && metalFilter != ''){
         if(shapeFilter == variantShape && metalFilter == variantMetal){
           variantData = getProductSelectedOption(option,productHandle,productMedia,collectionHandel);
            
         }
       }else if(shapeFilter == '' && metalFilter != ''){
         if(metalFilter == variantMetal){  
            if(i == 0){
              variantData = getProductSelectedOption(option,productHandle,productMedia,collectionHandel); 
              
              i++;
            }              
         }
       }else if(shapeFilter != '' && metalFilter == ''){
         if(shapeFilter == variantShape){       
           if(i == 0){
             variantData = getProductSelectedOption(option,productHandle,productMedia,collectionHandel);
              
             i++;
           }
         }
       }
     });
  }
  return variantData;   
}

function getProductSelectedOption(option,productHandle,productMedia,collectionHandel){
  
   var variantInfo = new Array();
   var variantShape = option.option1;
   var variantMetal = option.option2;
   var varientImage = placeholderImageUrl.ring_placeholder;
   var varientFeaturedImage  = option.image_id;
   
   if(varientFeaturedImage != null){
     varientImage = getImageByID(productMedia,option.image_id)
   } 
 
   var productUrl = '/collections/'+collectionHandel+'/products/'+productHandle+'?variant='+option.id+'&sku='+option.sku;
  
   variantInfo.push({
      id: option.id,
      sku: option.sku,
      shape: variantShape,
      metal: variantMetal,
      url: productUrl,
      image: varientImage,
      price: option.price,
   });

  return variantInfo;
}
/*** Get variant Data After Filter Apply End ***/

/*** Get Product Swatches Data Start ***/
function getProductSwatches(product,collectionHandel){
  // console.log(product);
   var swatchesData = new Array();
   var productVariants = product.variants;
   var productImages = product.images;
   var shapeFilter = jQuery("#setting_shape").val(); 
   var metalFilter = jQuery("#setting_metal").val();
  
  console.log(productVariants);
  
   if(productVariants != ''){
     $(productVariants).each(function(index, option){          
         var variantShape = option.option1;
         var variantMetal = option.option2;
         var metalClass = variantMetal.toLowerCase();
         metalClass = metalClass.replace(/\s+/g,"-");         

         if(shapeFilter != '' && variantShape == shapeFilter){
             var active = '';
             if(metalFilter == variantMetal){
               var active = 'active'; 
             }
             var productUrl = '/collections/'+collectionHandel+'/products/'+product.handle+'?variant='+option.id+'&sku='+option.sku;
             var imageUrl = getImageByID(productImages,option.image_id);
           
             swatchesData.push({
                id: option.id,
                sku: option.sku,
                metal: variantMetal,
                shape: variantShape,
                class: metalClass,
                url: productUrl,
                active: active,
                image: imageUrl,
                price: option.price,
             });
         }else if(shapeFilter == ''){
             var active = '';
             if(metalFilter == variantMetal){
               var active = 'active'; 
             }
           
             var productUrl = '/collections/'+collectionHandel+'/products/'+product.handle+'?variant='+option.id+'&sku='+option.sku;             
             var imageUrl = getImageByID(productImages,option.image_id);
           
             if(index <= 3){
               swatchesData.push({
                  id: option.id,
                  sku: option.sku,
                  metal: variantMetal,
                  shape: variantShape,
                  class: metalClass,
                  url: productUrl,
                  active: active,
                  image: imageUrl,
                  price: option.price,
               });
             }
         }
           
     });
   }
   return swatchesData;
}
/*** Get Product Swatches Data End ***/

/*** Get Image URL By Its ID Start ***/
function getImageByID(productImages,imageId) {
  var imageUrlArray = new Array();
  $(productImages).each(function(index, image){   
    if(image.id == imageId){
      var imageUrl = image.src;
      imageUrlArray.push(imageUrl);
    }
  });

  return imageUrlArray[0];
}
/*** Get Image URL By Its ID End ***/
  
/*** Abort XHR Start ***/
function abortAjax(xhr) {
  if(xhr && xhr.readystate != 4){
    xhr.abort();
  }
}
/*** End ***/ 

/*** Onclick Product Store Product ID & PAge No in Session Start ***/
jQuery(document).on("click", ".tps-productlist-result-grid-view-item", function(e) {
  var data_page_no = $(this).attr("data-page");
  var data_product_id = $(this).attr("data-id");
  
  updateSessionFilters(session_variable+'-other-data','Recent-Product-Page-No', data_page_no);
  updateSessionFilters(session_variable+'-other-data','Product-Id', data_product_id);
});
/*** Onclick Product Store Product ID & PAge No in Session End ***/

/*** Empty Diamond Result Div On Filter Click Start ***/
function emptyProductResultDiv(){   
  jQuery('.tps-productlist-result-grid-view-items-list').removeClass('tps-no-product-found');
  jQuery('.tps-productlist-result-grid-view-items-list').html('');
  var resetFlag = checkResetFlag();
  if(resetFlag != 'true'){
    ajaxDataCall();
  } 
}
/*** End ***/

/*** Reset Filters Start ***/
function resetFilters(){
  var session_variable = jQuery("#session_variable").val();
  localStorage.removeItem(session_variable+'-filters');   
  localStorage.setItem('resetFlag', 'true');
  jQuery(".tps-reset-filter-confirm-popup-div").hide();
  
  if(typeof(Storage) !== "undefined"){
    $('.tps-selected-filter-wrapper').hide();
    $('.tps-selected-filter-container ul').remove();
    
    $('.tps-filter-shape-li').removeClass('selected');
    $(".tps-filter-shape-checkbox").prop('checked', false);
    $('#setting_shape').val('');

    $('.tps-filter-metal-li').removeClass('selected');
    $(".tps-filter-metal-checkbox").prop('checked', false);
    $('#setting_metal').val('');

    $('.tps-filter-style-li').removeClass('selected');
    $(".tps-filter-style-checkbox").prop('checked', false);
    $('#setting_style').val('');

    price_slider_render(default_price_min, default_price_max, true, translations.titlePrice);     

    $('.tps-sort-option').removeClass('active');
    $('.tps-sort-price-ascending').addClass('active');
    jQuery('.tps-sort-by-value').html('<span>'+translations.titlePriceSortLowToHigh+'</span>');
    jQuery('#sort_by').val('price-ascending');     

    updateSessionFilters(session_variable+'-other-data','Sort-By', 'price-ascending');
    updateSessionFilters(session_variable+'-other-data','Sort-Title', translations.titlePriceSortLowToHigh);
    
    jQuery('#page_no').val(1);
    ajaxDataCall();

    setTimeout(function(){
      localStorage.setItem('resetFlag','false');
    }, 1000);
  }
}
/*** End ***/

/*** Check Reset Flag Start ***/
function checkResetFlag() {
  var resetFlag = localStorage.getItem('resetFlag');
  return resetFlag;
}
/*** Check Reset Flag End ***/

/*** Reset Filter Popoup Close Outer Click Start ***/
jQuery(document).on('click','#MainContent',function(e){
  var container = $(".tps-tab2");
    
  // If the target of the click isn't the container
  if(!container.is(e.target) && container.has(e.target).length === 0){     
    jQuery(".tps-reset-filter-confirm-popup-div").hide();
  }
});
/*** Reset Filter Popoup Close Outer Click End ***/

/*** Change Product Image Function ***/
function changeProductImage(event, productId, direction) {
  // Stop event propagation to prevent redirect
  event.stopPropagation();
  event.preventDefault();
  
  console.log('Change product image called for:', productId, 'Direction:', direction);
  
  // Find the image element
  var imgElement = jQuery('img[data-product-id="'+productId+'"]');
  if (imgElement.length === 0) {
    console.log('Image element not found');
    return;
  }
  
  var currentIndex = parseInt(imgElement.attr('data-current-index'));
  var imageList = imgElement.attr('data-image-list').split(',');
  
  // Only navigate if we have more than one image
  if (imageList.length <= 1) {
    console.log('Only one image available, no navigation needed');
    return;
  }
  
  // Calculate the new index based on direction
  var newIndex;
  if (direction === 'next') {
    newIndex = (currentIndex + 1) % imageList.length;
  } else {
    newIndex = (currentIndex - 1 + imageList.length) % imageList.length;
  }
  
  console.log('Changing from index', currentIndex, 'to', newIndex, 'Image:', imageList[newIndex]);
  
  // Fade transition effect
  imgElement.css('opacity', '0.5');
  
  // Update the image source and index
  imgElement.attr('data-current-index', newIndex);
  
  // Preload the new image
  var newImage = new Image();
  newImage.onload = function() {
    imgElement.attr('src', imageList[newIndex]);
    imgElement.animate({opacity: 1}, 300);
  };
  newImage.src = imageList[newIndex];
}

// Add touch swipe functionality for mobile devices
jQuery(document).ready(function() {
  // Add CSS styles for product image navigation
  var arrowStyles = `
    <style>
      .tps-product-img-nav {
        position: relative;
        display: block;
      }
      .tps-product-arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        background: rgba(255, 255, 255, 0.8);
        color: #333;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        text-align: center;
        line-height: 36px;
        font-size: 20px;
        font-weight: bold;
        cursor: pointer;
        z-index: 99;
        display: none;
        box-shadow: 0 2px 5px rgba(0,0,0,0.3);
        transition: all 0.2s ease;
        user-select: none;
      }
      .tps-diamond-prev-arrow {
        left: 10px;
        width: 52px;
        height: 52px;
        background: rgba(255, 255, 255, 0.75);
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
        border-radius: 50px;
      }
      .tps-diamond-next-arrow {
        right: 10px;
        width: 52px;
        height: 52px;
        background: rgba(255, 255, 255, 0.75);
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
        border-radius: 50px;
      }

      .tps-diamond-arrow.tps-diamond-next-arrow svg {
        transform: matrix(0, -1, -1, 0, 0, 0);
        width: 28px;
        height: 28px;
        transform: matrix(0, -1, -1, 0, 0, 0);
        margin-top: 11px;
        margin-left: 3px;
      }

      .tps-diamond-arrow.tps-diamond-prev-arrow svg {
        transform: matrix(0, 1, 1, 0, 0, 0);
        width: 28px;
        height: 28px;
        transform: matrix(0, 1, 1, 0, 0, 0);
        margin-top: 11px;
      }
      .tps-productlist-item-media-div:hover .tps-product-arrow {
        display: block;
      }
      .tps-product-arrow:hover {
        background: rgba(255, 255, 255, 0.95);
        transform: translateY(-50%) scale(1.1);
      }
      .tps-productlist-item-img {
        transition: opacity 0.3s ease;
      }
    </style>
  `;
  jQuery('head').append(arrowStyles);
  
  // Variables to track touch events
  var touchStartX = 0;
  var touchEndX = 0;
  var touchStartY = 0; // Track vertical position to distinguish between scroll and swipe
  var minSwipeDistance = 50; // Minimum distance (in px) to consider as a swipe
  var isImageSwiping = false; // Flag to track if we're swiping an image
  
  // Add event listeners for touch events on product images
  jQuery(document).on('touchstart', '.tps-productlist-item-img', function(e) {
    // Get the initial touch coordinates
    touchStartX = e.originalEvent.touches[0].clientX;
    touchStartY = e.originalEvent.touches[0].clientY;
    
    // Check if this image has multiple images (swipeable)
    var imageList = jQuery(this).attr('data-image-list');
    if (imageList && imageList.split(',').length > 1) {
      isImageSwiping = true;
    }
  });
  
  jQuery(document).on('touchmove', '.tps-productlist-item-img', function(e) {
    if (!isImageSwiping) return;
    
    // Calculate the horizontal distance moved
    var currentX = e.originalEvent.touches[0].clientX;
    var currentY = e.originalEvent.touches[0].clientY;
    var deltaX = currentX - touchStartX;
    var deltaY = Math.abs(currentY - touchStartY);
    
    // If horizontal swipe is greater than vertical movement and significant enough
    if (Math.abs(deltaX) > 20 && Math.abs(deltaX) > deltaY) {
      // Prevent page scrolling
      e.preventDefault();
      
      // Add visual feedback - slight movement in the direction of the swipe
      var moveDistance = Math.min(15, Math.abs(deltaX) / 5); // Limit the movement
      jQuery(this).css('transform', 'translateX(' + (deltaX > 0 ? moveDistance : -moveDistance) + 'px)');
    }
  });
  
  jQuery(document).on('touchend', '.tps-productlist-item-img', function(e) {
    if (!isImageSwiping) return;
    
    // Reset the transform
    jQuery(this).css('transform', 'translateX(0)');
    
    touchEndX = e.originalEvent.changedTouches[0].clientX;
    handleProductImageSwipe(this);
    isImageSwiping = false;
  });
  
  jQuery(document).on('touchcancel', '.tps-productlist-item-img', function(e) {
    // Reset the transform and flag on touch cancel
    jQuery(this).css('transform', 'translateX(0)');
    isImageSwiping = false;
  });
  
  // Function to handle swipe and change image
  function handleProductImageSwipe(imgElement) {
    // Calculate distance
    var distance = touchEndX - touchStartX;
    
    // If the swipe is too small, don't do anything
    if (Math.abs(distance) < minSwipeDistance) return;
    
    // Get product ID from the image
    var productId = jQuery(imgElement).attr('data-product-id');
    if (!productId) return;
    
    // Determine swipe direction and change image
    var direction = distance > 0 ? 'prev' : 'next'; // Swipe right goes to previous, swipe left goes to next
    console.log('Swipe detected:', direction);
    
    // Create a synthetic event object for the changeProductImage function
    var event = {
      stopPropagation: function() {},
      preventDefault: function() {}
    };
    
    // Call the image change function
    changeProductImage(event, productId, direction);
  }
});